export default {
  title: 'Preços de Módulos',
  description: 'Defina o preço de cada configuração contratável de um módulo comercializável. O código identifica a configuração (no CRM, a combinação de capacidades, como 250-10).',
  labels: {
    new: 'Novo preço',
  },
  form: {
    title: 'Preço de módulo',
  },
  groups: {
    data: 'Preço base',
  },
  fields: {
    module: 'Módulo comercializável',
    code: 'Código',
    price: 'Preço',
    priceUsd: 'Preço (USD)',
    suggestedPrice: 'Preço sugerido (USD)',
    displayCurrency: 'Moeda de visualização',
    displayCurrencyHelp: 'O preço-base e a edição são sempre em USD; a moeda selecionada altera somente a visualização.',
  },
  actions: {
    acceptSuggestion: 'Aceitar sugestão',
    activate: 'Ativar',
    deactivate: 'Desativar',
  },
  messages: {
    saved: 'Preço atualizado.',
    unconfigured: 'Não configurado',
    localPricePending: 'Preço local pendente',
    legacyCurrencyReview: 'Revisar valor legado',
    suggestionPending: 'Pendente',
    displayCurrency: 'Moeda de visualização',
    chooseCurrency: 'Selecione a moeda',
  },
};
